export const REGEXP = {
  // eslint-disable-next-line max-len
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[[\]|\\/+=@$!%_*?&)(}{><^#])[A-Za-z\d[\]|\\/+=@$!_*?&)(}{^#]{8,32}$/,
  // eslint-disable-next-line max-len
  EMAIL: /^([1-9a-zA-Z-_][0-9a-zA-Z-_+]+(\.[0-9a-zA-Z-_+]+)?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
  WEBSITE_URL: /^((https?|ftp|smtp):\/\/)?(www.)?[a-zA-Z0-9]+\.[a-zA-Z]+(\/[a-zA-Z0-9#]+\/?)*$/,
};
